function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.494 51C13.33 50.997 2.861 42.4.491 30.468c-2.37-11.932 4.02-23.876 15.26-28.528 11.24-4.651 24.202-.715 30.956 9.403 6.755 10.117 5.422 23.597-3.183 32.196A25.43 25.43 0 0125.494 51zm0-49.87c-11.614.002-21.61 8.208-23.876 19.6C-.647 32.122 5.45 43.527 16.18 47.972c10.73 4.446 23.107.692 29.56-8.964 6.455-9.657 5.19-22.528-3.021-30.742A24.286 24.286 0 0025.494 1.13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.94 20.244l8.735-8.733.813.813-8.734 8.734z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37 24H27V14h1.154v8.846H37zM11.128 39.057l8.734-8.733.814.813-8.734 8.734z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 38h-1.154v-8.846H13V28h10z"
}));

function SvgMoreViewsMenuClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 51"
  }, props), _ref);
}

export default SvgMoreViewsMenuClose;